import { render, staticRenderFns } from "./RelationSelect.vue?vue&type=template&id=2b930588&"
import script from "./RelationSelect.vue?vue&type=script&lang=js&"
export * from "./RelationSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports